import css from '../css-snippets/section-card-with-slider-rivoneed';
import containerFuild from '../html-snippets/container-fuild';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="card-title" data-show="true" class="card-title">
      <h2>Multiple Modes. Adapt To Any Task.</h2>
      <p>See every detail clearly and finish repairs faster with less effort.</p>
    </div>
    <div
      data-attribute="wrap-content-card"
      data-width="549"
      data-align="left"
      class="wrap-content-card"
      style="--width-content-card: 549px; --align-content-card: flex-start"
    >
      <div class="block-content">
        <div class="block-slider">
          <div class="swiper">
            <div data-attribute="list-item" class="swiper-wrapper">
              <div data-attribute="item-slide" class="swiper-slide">
                <div
                  data-attribute="wrap-item-slide"
                  class="wrap-item-slide"
                  data-overlay-opacity="0"
                  style="--overlay-opacity: 0"
                >
                  <div class="wrap-image">
                    <img
                      data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bdf3744ea7cdecdbe70dc.jpg"
                      alt=""
                    />
                  </div>
                  <div data-attribute="title-item" class="title-item">
                    <h3>Bright White</h3>
                  </div>
                </div>
              </div>
              <div data-attribute="item-slide" class="swiper-slide">
                <div
                  data-attribute="wrap-item-slide"
                  class="wrap-item-slide"
                  data-overlay-opacity="0"
                  style="--overlay-opacity: 0"
                >
                  <div class="wrap-image">
                    <img
                      data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cb8a053923d91bbfb7741.webp?w=50&h=50&q=80"
                      alt=""
                    />
                  </div>
                  <div data-attribute="title-item" class="title-item">
                    <h3>Comfort Yellow</h3>
                  </div>
                </div>
              </div>
              <div data-attribute="item-slide" class="swiper-slide">
                <div
                  data-attribute="wrap-item-slide"
                  class="wrap-item-slide"
                  data-overlay-opacity="0"
                  style="--overlay-opacity: 0"
                >
                  <div class="wrap-image">
                    <img
                      data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cb8b880ee94456d9cd915.webp"
                      alt=""
                    />
                  </div>
                  <div data-attribute="title-item" class="title-item">
                    <h3>Alert Red</h3>
                  </div>
                </div>
              </div>
              <div data-attribute="item-slide" class="swiper-slide">
                <div
                  data-attribute="wrap-item-slide"
                  class="wrap-item-slide"
                  data-overlay-opacity="0"
                  style="--overlay-opacity: 0"
                >
                  <div class="wrap-image">
                    <img
                      data-attribute="image-item"
                      src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cb8dd525901fcb96ada4c.webp"
                      alt=""
                    />
                  </div>
                  <div data-attribute="title-item" class="title-item">
                    <h3>4 Level Brightness</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wrap-pagination">
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div data-attribute="wrap-benefis" class="block-benefits">
          <div data-attribute="item-benefit" class="item-benefit">
            <div class="icon-item-benefit">
              <img src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bcf24d2e624d0a3851246.png" alt="" />
            </div>
            <div class="text-item-benefit">
              <p>Choose the ideal light color for work, repairs, or outdoor use.</p>
            </div>
          </div>
          <div data-attribute="item-benefit" class="item-benefit">
            <div class="icon-item-benefit">
              <img src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bcf24d2e624d0a3851246.png" alt="" />
            </div>
            <div class="text-item-benefit">
              <p>Set the perfect brightness for comfort, visibility, and runtime.</p>
            </div>
          </div>
          <div data-attribute="item-benefit" class="item-benefit">
            <div class="icon-item-benefit">
              <img src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bcf24d2e624d0a3851246.png" alt="" />
            </div>
            <div class="text-item-benefit">
              <p>Illuminate far beyond your surroundings with confidence.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bd05c4613ff5cced7a648.webp',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cbd351020d5ccf1fdef54.webp',
  textColor: '#ffffff',
});
